import { render, staticRenderFns } from "./Formularios.vue?vue&type=template&id=49ad1343&"
import script from "./Formularios.vue?vue&type=script&lang=js&"
export * from "./Formularios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports